import script from "./SocialMediaComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialMediaComponent.vue?vue&type=script&setup=true&lang=js"

import "./SocialMediaComponent.vue?vue&type=style&index=0&id=6e1b081b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e1b081b"]])

export default __exports__